import React, { useState, useEffect } from "react";
import Home from "./HomeContainer";
import ModalContainer from "./ModalContainer";
import UserMenu from "../user/UserMenu";
import authHeaders from "../utilities/authHeaders";
import notification from "../utilities/notification";
import getToken from "../utilities/getToken";
import Header from "./Header";

const App = () => {
  const [currentUser, setCurrentUser] = useState("");
  const [currentUserAvatar, setCurrentUserAvatar] = useState(null);
  const [errors, setErrors] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [locationMode, setLocationMode] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [modal, setModal] = useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [notificationId, setNotificationId] = useState("");
  const [postId, setPostId] = useState(null);
  const [posts, setPosts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    if (getToken()) {
      const url = `${process.env.REACT_APP_HOST}/api/v1/users/register/edit`;
      fetch(url, {
        headers: authHeaders(),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((response) => {
              const name = response.data.attributes.username;
              const avatar = response.data.attributes.avatar;
              login(name, avatar);
            });
          } else {
            localStorage.removeItem("user");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, []);

  const login = (name, avatar) => {
    setLoggedIn(true);
    setCurrentUser(name);
    setCurrentUserAvatar(avatar);
  };

  const logout = () => {
    localStorage.removeItem("user");
    setLoggedIn(false);
    setCurrentUser("");
    setCurrentUserAvatar(null);
    setModal("");
  };

  const handleLogout = () => {
    setShowMenu(false);
    const url = `${process.env.REACT_APP_HOST}/api/v1/users/logout`;
    fetch(url, {
      method: "DELETE",
      headers: authHeaders(),
    }).then((response) => {
      if (response.ok) {
        logout();
        notification("Logout successful", "success", 3000);
      } else {
        notification("Could not sign out", "danger", 3000);
      }
    });
  };

  const openModal = () => {
    setIsOpen(true);
    setSelected(null);
  };

  return (
    <>
      <Header
        loggedIn={loggedIn}
        openModal={openModal}
        mapLoaded={mapLoaded}
        modalIsOpen={modalIsOpen}
        setModal={setModal}
        setShowMenu={setShowMenu}
      />
      <Home
        currentUser={currentUser}
        loaded={loaded}
        locationMode={locationMode}
        modalIsOpen={modalIsOpen}
        notificationId={notificationId}
        postId={postId}
        posts={posts}
        selected={selected}
        setErrors={setErrors}
        setLoaded={setLoaded}
        setLocationMode={setLocationMode}
        setMapLoaded={setMapLoaded}
        setNotificationId={setNotificationId}
        setPosts={setPosts}
        setSelected={setSelected}
        setShowMenu={setShowMenu}
        setShowSearch={setShowSearch}
        showSearch={showSearch}
      />
      {!modalIsOpen && loaded ? (
        <UserMenu
          currentUserAvatar={currentUserAvatar}
          handleLogout={handleLogout}
          loggedIn={loggedIn}
          openModal={openModal}
          setShowMenu={setShowMenu}
          setShowSearch={setShowSearch}
          setModal={setModal}
          showMenu={showMenu}
        />
      ) : null}
      <ModalContainer
        currentUser={currentUser}
        currentUserAvatar={currentUserAvatar}
        errors={errors}
        loggedIn={loggedIn}
        login={login}
        logout={logout}
        modal={modal}
        modalIsOpen={modalIsOpen}
        posts={posts}
        setCurrentUser={setCurrentUser}
        setCurrentUserAvatar={setCurrentUserAvatar}
        setErrors={setErrors}
        setNotificationId={setNotificationId}
        setIsOpen={setIsOpen}
        setLocationMode={setLocationMode}
        setPostId={setPostId}
        setPosts={setPosts}
        setSelected={setSelected}
      />
    </>
  );
};

export default App;
